<div class="doctor_data" [formGroup]="medicoForm">
  <p><strong>{{ 'Dados do médico' | translate}}</strong></p>
  <!--div class="doctor_data__itens" *ngFor="let medico of medicos.controls; let i = index" [formGroupName]="i"-->
  <div class="doctor_data__itens">
    
    <div class="div">
      <div class="flex gap-1">

        <div class="institution_data__nome">
          <label><strong>{{ 'Nome' | translate}}:</strong></label>
          <ng-container *ngIf="isSmartCase; else medicoNormalInput">
            <input type="text"formControlName="nome"  (keypress)="validarEntrada.emit($event)" class="name_size" appClearOnAltD appSmartCase />
          </ng-container>
          <ng-template #medicoNormalInput>
            <input type="text" formControlName="nome" (keypress)="validarEntrada.emit($event)" class="name_size" appClearOnAltD appLowercaseOnChange />
            <!-- [matAutocomplete]="autoNomeMedico" -->
          </ng-template>
          <mat-autocomplete #autoNomeMedico="matAutocomplete" (optionSelected)="onMedicoSelecionado($event.option.value)">
            <mat-option *ngFor="let nomeItem of nomeMedicoFiltrado | slice:0:6" [value]="nomeItem">
              {{ nomeItem.nome | lowercaseCustom }} | {{ nomeItem.matricula | lowercaseCustom }} | {{ nomeItem.especialidade | lowercaseCustom }}
            </mat-option>
            <mat-option *ngIf="nomeMedicoFiltrado.length === 0" disabled>
              {{ 'Sem sugestões' | translate}}
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="institution_data__nome">
          <label><strong>{{ 'E-mail' | translate}}:</strong></label>
          <ng-container *ngIf="isSmartCase; else medicoEmailInput">
            <input type="text" formControlName="email" (keypress)="validarEntrada.emit($event)" class="email_size" appClearOnAltD appSmartCase />
          </ng-container>
          <ng-template #medicoEmailInput>
            <input type="text" formControlName="email" (keypress)="validarEntrada.emit($event)" class="email_size" appClearOnAltD appLowercaseOnChange />
          </ng-template>
        </div>
      </div>

      <div class="flex gap-1 scrolly">
        <div class="institution_data__nome">
          <label><strong>{{ 'CRM' | translate}}:</strong></label>
          <ng-container *ngIf="isSmartCase; else medicoMatriculaInput">
            <input type="text" formControlName="matricula"(keypress)="validarEntrada.emit($event)" class="matricula_size" appClearOnAltD appSmartCase />
          </ng-container>
          <ng-template #medicoMatriculaInput>
            <input type="text" formControlName="matricula"(keypress)="validarEntrada.emit($event)" class="matricula_size" appClearOnAltD appLowercaseOnChange />
            <!-- [matAutocomplete]="autoCRM" -->
          </ng-template>
          <mat-autocomplete #autoCRM="matAutocomplete" (optionSelected)="onMedicoSelecionado($event.option.value)">
            <mat-option *ngFor="let matriculaItem of crmFiltrado | slice:0:5" [value]="matriculaItem">
              {{ matriculaItem.matricula | lowercaseCustom }}
            </mat-option>
            <mat-option *ngIf="crmFiltrado.length === 0" disabled>
              {{ 'Sem sugestões' | translate}}
            </mat-option>
          </mat-autocomplete>
        </div>

        <!--div class="institution_data__nome" *ngFor="let esp of medico.get('especialidade').controls; let j = index"-->

        <div class="institution_data__nome" *ngFor="let esp of especialidadeArray.controls; let j = index">
          <label><strong>{{ 'Especialidade' | translate}} {{j + 1}}:</strong></label>
          
          <ng-container *ngIf="isSmartCase; else medicoEspecialidadeInput">
            <input type="text" [formControl]="esp" (keypress)="validarEntrada.emit($event)" class="especialidade_size" (keyup)="verificarAtalho($event, j)" appClearOnAltD appSmartCase  #especialidadeInput />
          </ng-container>
          <ng-template #medicoEspecialidadeInput>
            <input type="text" [formControl]="esp" (keypress)="validarEntrada.emit($event)" class="especialidade_size" (keyup)="verificarAtalho($event, j)" appClearOnAltD appLowercaseOnChange  #especialidadeInput />
            <!-- [matAutocomplete]="autoEspecialidade" -->
          </ng-template>
          
          <button type="button" class="addRemoveButton" (click)="removeEspecialidade(j)" *ngIf="j>=1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
          </button>
          <mat-autocomplete #autoEspecialidade="matAutocomplete">
            <mat-option *ngFor="let espItem of especialidadeFiltrado | slice:0:5" [value]="espItem">
              {{ espItem | lowercaseCustom }}
            </mat-option>
            <mat-option *ngIf="especialidadeFiltrado.length === 0" disabled>
              {{ 'Sem sugestões' | translate}}
            </mat-option>
          </mat-autocomplete>
        </div>
        <div class="">
          <button type="button"  class="addRemoveButton buttonSpecial" (click)="addEspecialidade()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aa0012" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
          </button>
        </div>
      </div>
    </div>

    <div class="flex_small" *ngIf="isVisibleEnderecoMedico">
      <div class="flex gap-1">
        <div class="doctor_data__nome">
          <label><strong>{{ 'Rua' | translate}}:</strong></label>
            
          <ng-container *ngIf="isSmartCase; else medicoRuaInput">
            <input type="text" formControlName="rua" (keypress)="validarEntrada.emit($event)" class="address_size" appClearOnAltD appSmartCase />
          </ng-container>
          <ng-template #medicoRuaInput>
            <input type="text" formControlName="rua" (keypress)="validarEntrada.emit($event)" class="address_size" appClearOnAltD appLowercaseOnChange />
          </ng-template>
          
        </div>
        
        <div class="doctor_data__nome">
          <label><strong>{{ 'Cidade' | translate}}:</strong></label>
            
            <ng-container *ngIf="isSmartCase; else medicoLocalidadeInput">
              <input type="text" formControlName="localidade" (keypress)="validarEntrada.emit($event)" class="local_size" appClearOnAltD appSmartCase />
            </ng-container>
            <ng-template #medicoLocalidadeInput>
              <input type="text" formControlName="localidade" (keypress)="validarEntrada.emit($event)" class="local_size" appClearOnAltD  appLowercaseOnChange />
            </ng-template>
            
        </div>
      </div>

      <div>
        <div formArrayName="telefone" class="flex gap-1">
          <div *ngFor="let tel of telefoneArray.controls | slice:0:2; let j = index">
            <label><strong>Telefone {{j + 1}}:</strong></label>
            
            <ng-container *ngIf="isSmartCase; else medicoTelefoneInput">
              <input [formControl]="tel" (keypress)="validarEntrada.emit($event)" class="phone_size" appClearOnAltD appSmartCase />
            </ng-container>
            <ng-template #medicoTelefoneInput>
              <input [formControl]="tel" (keypress)="validarEntrada.emit($event)" class="phone_size" appClearOnAltD appLowercaseOnChange />
            </ng-template>
            
            <!--button type="button" class="addRemoveButton" (click)="removeMedicoTelefone(j)" *ngIf="j>=1">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            </button-->
          </div>
          
          <!--div class="">
            <button type="button"  class="addRemoveButton buttonSpecial" (click)="addMedicoTelefone()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aa0012" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            </button>
          </div-->
        </div>
      </div>
    </div>
  </div>
</div>